import AdyenBtn from '../../adyen-button';
import { AdyeConfig } from '../../../../../payment.helpers';
import { useAppSelector } from '../../../../../../../store';

const BancontactCardButton = () => {
    const { paymentOptionsData } = useAppSelector((state: RootState) => state.payment);
    const merchantData = paymentOptionsData?.adyen.find((adyenData: AdyeConfig) => adyenData.type === 'bcmc');

    return <AdyenBtn
        paymentType='bcmc'
        paymentMethodConfiguration={{
            name: merchantData?.name,
            type: merchantData?.type,
            // @ts-ignore
            brands: merchantData?.brands
        }}
    />;
};

export default BancontactCardButton;
